const translations = {
    emailValidation: {
        processing: 'Validating Email ...',
        completed: 'Successfaully validated email!',
        error: {
            expired: 'Email validation token is expired!',
            invalid: 'Email validation token is invalid!',
            validated: 'Email address already validated!',
            unknown: 'An error occurred validating your email!'
        }
    },
    passwordRecovery: {
        completed: 'Successfaully changed password!',
        error: {
            expired: 'Password recovery token is expired!',
            invalid: 'Password recovery token is invalid!',
            unknown: 'An error occurred changing your email!'
        }
    }
};

export default translations;